import {createUseStyles} from 'react-jss';
import Spacing from '../../style-helper/Spacing';

export default createUseStyles({
  pudoButtonLabel: {
    fontSize: 14,
    marginBottom: Spacing.half,
    marginTop: Spacing.quad,
  },
  pudoContent: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: props => props.theme.button.tab.fontWeight,
    color: '#4d4f53',
  },
  spinnerWrapper: {
    position: 'absolute',
    zIndex: 99,
    left: 0,
    right: 0,
    background: 'rgba(#999, 0.1)',
    textAlign: 'center',
  },
  icon: {
    width: '1.4em',
    height: '1.4em',
    marginRight: 6,
    marginLeft: 0,
    color: '#000',
  },
  pencilIcon: {
    width: 16,
    height: 16,
  },
  hasNoSelectedPudoPointError: {
    marginTop: Spacing.single,
  },
});
